import { initializeGallery } from "Functions/lightgallery";

document.addEventListener("DOMContentLoaded", () => {
    initializeGallery();
});
